import React, { useState } from "react";
import Add from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { FullScreenDialog } from "../core/FullScreenDialog";
import { SmartTextField } from "./SmartTextField";
import { SmartDateField } from "../core/SmartDateField";
import { PublisherSelect } from "./royalties/PublisherSelect";
import { useCreateGameEdition } from "@seabrookstudios/pitch2table";
import { DateTime } from "luxon";

/** @type {(import("@seabrookstudios/pitch2table-core").PublisherId|"unset")} */
const initialPublisherId = /** @type {import("@seabrookstudios/pitch2table-core").PublisherId} */ ("unset");

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {import("react").ReactNode} [props.CustomControl]
 */
export default function AddGameEditionFullScreenDialog({ gameId, CustomControl = undefined }) {
  const [name, setName] = useState("");
  const [datePublished, setDatePublished] = useState(DateTime.now().toMillis());
  const [publisherId, setPublisherId] = useState(initialPublisherId);

  const createEdition = useCreateGameEdition(gameId);

  const onSaveHandler = async () => {
    await createEdition.mutateAsync({
      name: name.trim(),
      datePublished,
      publisherId: publisherId === "unset" ? undefined : publisherId,
    });
  };

  return (
    <FullScreenDialog
      title="Add Edition"
      actionText="SAVE"
      onSaveHandler={onSaveHandler}
      canSave={name.trim().length === 0}
      isBusy={createEdition.isPending}
      CustomControl={
        CustomControl || (
          <IconButton color="primary" size="small">
            <Add />
          </IconButton>
        )
      }
    >
      <Stack spacing={2}>
        <SmartTextField
          required
          label="Edition Name"
          helperText="What is this release called? e.g. 'First Edition'"
          onChange={setName}
        />
        <SmartDateField
          initialValue={DateTime.now().toMillis()}
          label="Date Published"
          helperText="When was this edition released?"
          onChange={setDatePublished}
        />
        <PublisherSelect
          gameId={gameId}
          value={publisherId}
          onChange={setPublisherId}
          helperText="Which publisher released this edition?"
        />
      </Stack>
    </FullScreenDialog>
  );
}
